import AbstractBanner from './AbstractBanner/AbstractBanner';
import I18n from 'I18n';
import { getScopes } from '../../selectors';
import { useSelector } from 'react-redux';
import { memo, useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ACCOUNT_TYPES_DOC = 'https://developers.hubspot.com/hubspot-account-types';
export let Scope;
(function (Scope) {
  Scope["CRM_ACCESS"] = "full-crm-access";
  Scope["MARKETING_PRODUCT_ACCESS"] = "marketing-product-access";
  Scope["DEVELOPERS_PORTAL_ACCESS"] = "developers-portal-access";
})(Scope || (Scope = {}));
const isDeveloperPortal = scopes => {
  if (!scopes.includes(Scope.DEVELOPERS_PORTAL_ACCESS)) {
    return false;
  }
  /**
   * If the user has these scopes, even if they have developer portal access,
   * it is considered a hybrid portal and the banner should not be shown
   */
  if (scopes.includes(Scope.MARKETING_PRODUCT_ACCESS) || scopes.includes(Scope.CRM_ACCESS)) {
    return false;
  }
  return true;
};
const DeveloperBanner = () => {
  const scopes = useSelector(getScopes);
  const isDevPortal = useMemo(() => isDeveloperPortal(scopes), [scopes]);
  const title = I18n.text('alerts.developer.title');
  const description = I18n.text('alerts.developer.description');
  const linkText = I18n.text('alerts.developer.linkText');
  return isDevPortal ? /*#__PURE__*/_jsx(AbstractBanner, {
    isCloseable: false,
    title: title,
    type: "info",
    "data-test-id": 'developer-banner',
    children: /*#__PURE__*/_jsxs(Text, {
      paddingInline: "200",
      children: [description, /*#__PURE__*/_jsx(Link, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: ACCOUNT_TYPES_DOC,
        external: true,
        paddingInlineStart: "200",
        children: /*#__PURE__*/_jsx("b", {
          children: linkText
        })
      })]
    })
  }) : null;
};
export default /*#__PURE__*/memo(DeveloperBanner);